<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  maxLength,
  requiredIf,
  numeric,
} from "vuelidate/lib/validators";

export default {
  name: "UpdateActionForm",
  data() {
    return {
      id: null,
      name: null,
      registration_method: null,
      visit_grace_period: 30,
      profile_photo: false,
      switch_user_type: false,
      isParentWithoutChildren : false,
      // other
      registration_method_list: [
        {
          id: "PRE_REGISTERED_ONLY",
          name: "Pre-registered only",
        },
        {
          id: "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED",
          name: "Pre-registration with approval required",
        },
        {
          id: "REGISTRATION_ALLOWED",
          name: "Registration allowed",
        },
        {
          id: "PRE_REGISTERED_BY_ADMIN",
          name: "Pre-registered by admin",
        },
        {
          id: "REGISTRATION_NOT_REQUIRED",
          name: "Registration not required",
        }
      ],
      showMandatoryDataForUserTypesList:[
        "PRE_REGISTERED_BY_ADMIN",
        "REGISTRATION_ALLOWED",
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED",
        "PRE_REGISTERED_ONLY"
      ],
      parent_user_type: null,
      submitted: false,
      userTypeDuplication : false,
    };
  },
  validations: {
    name: { required, maxLength: maxLength(20) },
    registration_method: { required },
    visit_grace_period: {
      required: requiredIf(function () {
        return this.onShowGracePeriodInput;
      }),
      numeric,
      maxLength: maxLength(4),
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("updateUserTypes");
    },
    onShowGracePeriodInput(value) {
      !value && (this.visit_grace_period = null);
      value && !this.visit_grace_period && (this.visit_grace_period = 30);
    },
    registration_method(value) {
      console.log("reg", value, this.id, this.getModalInfo);

      const userType = this.getModalInfo.settings.find(
        (item) => item.name == "registration_method"
      );

      if (
        userType.pivot.value !== "REGISTRATION_NOT_REQUIRED" &&
        value.name == "Registration not required" 
      )
        this.checkChangeRegMethod(this.id);
      else if (userType.pivot.value == "REGISTRATION_ALLOWED")
        this.checkChangeRegAllowed(this.getModalInfo.id);
      else this.resetChangeRegMethodMsg();
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("userType", [
      "getModalState",
      "getLoading",
      "getChangeRegMethodMsg",
    ]),
    showDataMandatorySection(){
      return this.registration_method?.id ? this.showMandatoryDataForUserTypesList.includes(this.registration_method.id) : false;
    },
    onShowGracePeriodInput() {
      if (this.registration_method) {
        return (
          this.registration_method.name == "Pre-registered only" ||
          this.registration_method.name ==
            "Pre-registration with approval required"
        );
      }
      return false;
    },
    onShowSwitchUserType() {
      if (this.registration_method) {
        return this.registration_method.name == "Pre-registered by admin";
      }
      return false;
    },
    onShowUndefinedUsersText() {
      if (this.registration_method) {
        return this.registration_method.name == "Registration not required";
      }
      return false;
    },
  },
  methods: {
    ...mapActions("userType", [
      "updateUserType",
      "resetState",
      "resetChangeRegMethodMsg",
      "resetChangeRegAllowedErr",
      "checkChangeRegMethod",
      "checkChangeRegAllowed",
      "fetchUserTypeDuplication",
    ]),
    checkUserTypeDuplication(value){
      this.userTypeDuplication = false;
      this.fetchUserTypeDuplication({entity_id : this.currentEntity.id, user_type_id : this.id, value : value}).then((data)=>{
        // console.log('data', data);
        this.userTypeDuplication = data.data;
      });
    },
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$error) {
        const {
          id,
          name,
          registration_method,
          visit_grace_period,
          switch_user_type,
          onShowGracePeriodInput,
          profile_photo
        } = this;

        if (onShowGracePeriodInput && visit_grace_period < 30) return;
        this.updateUserType({
          id,
          form: {
            userType: {
              name,
            },
            settings: {
              registration_method:
                registration_method && registration_method.id,
              visit_grace_period: visit_grace_period ? visit_grace_period : 30,
              switch_usertype: switch_user_type ? 1 : 0,
              profile_photo : this.showDataMandatorySection ? Number(profile_photo) : 0
            },
          },
        }).then(()=>{
          this.$emit('updateUserTypeOrDeleted');
        })
      }
    },
  },
  async beforeMount() {
    const { resetState, getModalInfo } = this;
    resetState();
    this.resetChangeRegMethodMsg();
    // await this.resetChangeRegAllowedErr();
    console.log("getModalInfo", this.getModalInfo);

    const userType = this.getModalInfo.settings.find(
      (item) => item.name == "registration_method"
    );
    if (userType.pivot.value == "REGISTRATION_ALLOWED")
      await this.checkChangeRegAllowed(this.getModalInfo.id);
    if (getModalInfo) {
      const { id, name, settings, parentId, children } = getModalInfo;
      this.name = name;
      this.id = id;

      if(!parentId && !children.length){ // check if user type has not parent or children
        this.isParentWithoutChildren = true;
      } else{
        this.registration_method_list.pop();
      } 

      console.log("this.isParentWithoutChildren", this.isParentWithoutChildren);
      settings.length > 0 &&
        settings.map((setting) => {
          switch (setting.name) {
            case "visit_grace_period":
              return (this.visit_grace_period = setting.pivot.value);
            case "switch_usertype":
              return (this.switch_user_type =
                setting.pivot.value == "0" ? false : true);
            case "registration_method":
              return this.registration_method_list.map((method) => {
                return (
                  method.id == setting.pivot.value &&
                  (this.registration_method = method)
                );
              });
              case "profile_photo":
                return this.profile_photo = !!(Number(setting.pivot.value))
            default:
              return "";
          }
        });
    }
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <p class="text-secondary mb-3">{{ $t('userTypes.form.editUserType') }}</p>
    <div class="form-groups">
      <!-- name   -->
      <div class="name mb-3">
        <label for="name" class="mb-0 no-wrap no-wrap input-label">{{ $t('common.name') }}:</label>
        <b-input
          id="name"
          name="name"
          type="text"
          v-model.trim="name"
          :placeholder="$t('common.enterName')"
          @input="checkUserTypeDuplication"
        />
        <div class="err-wrapper">
          <div v-if="userTypeDuplication">
            <span class="error-value">{{ $t('userTypes.form.userTypeNameAlreadyExists') }}</span>
          </div>
          <div v-if="submitted && !$v.name.required">
            <span class="error-value">{{ $t('userTypes.form.userTypeNameRequired') }}</span>
          </div>
          <div v-else-if="submitted && !$v.name.maxLength">
            <span class="error-value">{{ $t('common.validation.maximumLength20Characters') }}</span>
          </div>
        </div>
      </div>
      <!-- registration-method  -->
      <div class="registration-method mb-3">
        <label for="method" class="mb-0 no-wrap no-wrap input-label"
          >{{ $t('userTypes.registrationMethod') }}:</label
        >
        <div
          class="multi"
          :class="{
            'warning-field':
              getChangeRegMethodMsg &&
              registration_method.id != 'REGISTRATION_ALLOWED',
          }"
        >
          <multiselect
            id="userstypes"
            v-model="registration_method"
            :options="registration_method_list"
            :placeholder="$t('userTypes.registrationMethod')"
            label="name"
            :show-labels="false"
            :allowEmpty="true"
            :disabled="
              getChangeRegMethodMsg &&
              registration_method.id == 'REGISTRATION_ALLOWED'
            "
          />
        </div>

        <div class="err-wrapper" style="margin-top: 5px">
          <div v-if="submitted && !$v.registration_method.required">
            <span class="error-value">{{ $t('userTypes.form.registrationMethodRequired') }}</span>
          </div>
        </div>
        <p
          v-if="onShowUndefinedUsersText && !getChangeRegMethodMsg"
          class="mb-0 text-muted"
        >
          {{ $t('userTypes.form.undefinedUsersSignInCompanyAsThisUserTypeIfAdded') }}
        </p>
        <p
          v-if="getChangeRegMethodMsg"
          class="mb-0 text-muted"
          style="color: #f46a6a !important"
        >
          {{ getChangeRegMethodMsg
          }}{{ registration_method.id == "REGISTRATION_ALLOWED" ? "" : "." }}
        </p>
      </div>
      <!-- visit grace period  -->
      <div class="period mb-3" v-if="onShowGracePeriodInput">
        <label for="period" class="mb-0 no-wrap no-wrap input-label"
          >{{ $t('userTypes.form.visitGracePeriodInMinutes') }}</label
        >
        <b-input
          id="period"
          name="period"
          type="number"
          min="30"
          v-model="visit_grace_period"
          :placeholder="$t('userTypes.form.enterGracePeriodInMinutes')"
        />
        <div class="err-wrapper">
          <div v-if="submitted && !$v.visit_grace_period.required">
            <span class="error-value">{{ $t('userTypes.form.visitGracePeriodRequired') }}</span>
          </div>
          <div
            v-if="submitted && visit_grace_period && visit_grace_period < 30"
          >
            <span class="error-value"
              >{{ $t('userTypes.form.visitGracePeriodMustLeast30Minutes') }}</span
            >
          </div>
          <div v-else-if="submitted && !$v.visit_grace_period.maxLength">
            <span class="error-value">{{ $t('common.validation.maximumLength4Digits') }}</span>
          </div>
        </div>
      </div>
      <!-- switch user type  -->
      <div class="switch-user-type mb-3" v-if="onShowSwitchUserType">
        <b-form-checkbox
          v-model="switch_user_type"
          class="custom-checkbox-primary"
          checked
        >
          {{ $t('userTypes.form.giveUserAbilitySwitchUserType') }}
        </b-form-checkbox>
        <p class="mb-0 text-muted">
          {{ $t('userTypes.form.forExampleStaffMemberMessage') }}
        </p>
        <hr/>
      </div>
    </div>


    <div class="vp" v-if="showDataMandatorySection">
          <p class="vp-mb-12">{{ $t('userTypes.form.dataMandatoryToBeFilledByUser') }}</p>
          <b-form-checkbox
            class="custom-checkbox-primary"
            checked
            v-model="profile_photo"
          >
          {{ $t('userTypes.form.profilePhoto') }}
          </b-form-checkbox>
        </div>



    <div class="action-btns">
      <button
        :disabled="userTypeDuplication ||
          getLoading ||
          (getChangeRegMethodMsg &&
            registration_method.id != 'REGISTRATION_ALLOWED')
        "
        class="submit-btn btn btn-primary"
        size="md"
        @click="onSubmit"
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        <span v-else>{{ $t('common.update') }}</span>
      </button>
      <button
        class="btn btn-outline-danger cancel-btn"
        @click="$bvModal.hide('updateUserTypes')"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.update-user-type-wrapper {
  .form-groups {
    padding-bottom: 1%;
  }
  .input-label {
    width: 400px;
  }
  .action-btns {
    margin-top: 40px;
  }
}
</style>

<style lang="scss">
div#updateUserTypes___BV_modal_body_ {
  .warning-field {
    .multiselect__tags {
      border: 1.5px solid #f46a6a !important;
    }
  }
  
  .multiselect__content-wrapper {
    position: static;
}
}
</style>
